import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatToolbar } from '@angular/material/toolbar';
import {
  ButtonsContainerComponent,
  TypedFormControl,
  TypedFormGroup,
} from '@principle-theorem/ng-shared';
import { IParchmentIntegrationData } from '@principle-theorem/principle-core/interfaces';

export type IParchmentFormData = Pick<
  IParchmentIntegrationData,
  'organisationId' | 'organisationSecret' | 'userId'
>;

@Component({
  selector: 'pr-parchment-integration-form',
  templateUrl: './parchment-integration-form.component.html',
  styleUrls: ['./parchment-integration-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatToolbar,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    ButtonsContainerComponent,
  ],
})
export class ParchmentIntegrationFormComponent {
  form: TypedFormGroup<IParchmentFormData> =
    new TypedFormGroup<IParchmentFormData>({
      organisationId: new TypedFormControl<string>('', {
        validators: [Validators.required],
      }),
      organisationSecret: new TypedFormControl<string>('', {
        validators: [Validators.required],
      }),
      userId: new TypedFormControl<string>('', {
        validators: [Validators.required],
      }),
    });

  constructor(
    private _dialogRef: MatDialogRef<ParchmentIntegrationFormComponent>
  ) {}

  submit(): void {
    if (this.form.invalid) {
      return;
    }
    this._dialogRef.close(this.form.getRawValue());
  }
}
